module.exports = __webpack_public_path__ + "static/img/v_ba_p_5_1.8d982228.png";